// extracted by mini-css-extract-plugin
export default {"addToCartControl":"WY-z","giftCard":"XY-z","btnContainer":"YY-z","cartButton":"ZY-z","disabled":"_Y-z"};